export const SAVE_BACKUP_FORM =
  'ipfabric/Settings/System/BackupMaintenanceSAVE_BACKUP_FORM';
export const SAVE_MAINTENANCE =
  'ipfabric/Settings/System/BackupMaintenanceSAVE_MAINTENANCE';
export const START_MAINTENANCE =
  'ipfabric/Settings/System/BackupMaintenanceSTART_MAINTENANCE';
export const SETTING_SYSTEM_CLEAR_DB =
  'ipfabric/Settings/System/BackupMaintenanceSystem/SETTING_SYSTEM_CLEAR_DB';

export const CLEAR_DB_DIALOG_NAME = 'nimpeeSystemClearDb';
export const RESET_DB_SETTINGS_DIALOG_NAME = 'nimpeeSystemResetDbSettings';
